export default __webpack_public_path__ + "TGALoader-c2343bc183a8ccaf4d746edec50587c7.js";